var map = {
	"./App.scss": 418,
	"./WalletSrc": 177,
	"./WalletSrc.js": 177,
	"./bufficorn.png": 415,
	"./burnerloader.gif": 259,
	"./burnerwallet.png": 261,
	"./coinbase.jpg": 1097,
	"./components/Admin": 196,
	"./components/Admin.js": 196,
	"./components/Advanced": 195,
	"./components/Advanced.js": 195,
	"./components/Badge": 86,
	"./components/Badge.js": 86,
	"./components/Badges": 190,
	"./components/Badges.js": 190,
	"./components/Balance": 25,
	"./components/Balance.js": 25,
	"./components/BalanceDisplay": 419,
	"./components/BalanceDisplay.jsx": 419,
	"./components/Bottom": 29,
	"./components/Bottom.js": 29,
	"./components/BottomLinks": 248,
	"./components/BottomLinks.js": 248,
	"./components/BurnWallet": 200,
	"./components/BurnWallet.js": 200,
	"./components/CashOut": 192,
	"./components/CashOut.js": 192,
	"./components/Exchange": 201,
	"./components/Exchange.js": 201,
	"./components/Footer": 199,
	"./components/Footer.js": 199,
	"./components/Header": 180,
	"./components/Header.js": 180,
	"./components/History": 194,
	"./components/History.js": 194,
	"./components/Loader": 98,
	"./components/Loader.js": 98,
	"./components/MainCard": 193,
	"./components/MainCard.js": 193,
	"./components/Modal": 420,
	"./components/Modal.js": 420,
	"./components/MoreButtons": 97,
	"./components/MoreButtons.js": 97,
	"./components/NavCard": 24,
	"./components/NavCard.js": 24,
	"./components/Receipt": 191,
	"./components/Receipt.js": 191,
	"./components/Receive": 187,
	"./components/Receive.js": 187,
	"./components/RecentTransactions": 78,
	"./components/RecentTransactions.js": 78,
	"./components/RequestFunds": 185,
	"./components/RequestFunds.js": 185,
	"./components/Ruler": 14,
	"./components/Ruler.js": 14,
	"./components/SendBadge": 183,
	"./components/SendBadge.js": 183,
	"./components/SendByScan": 181,
	"./components/SendByScan.js": 181,
	"./components/SendToAddress": 182,
	"./components/SendToAddress.js": 182,
	"./components/SendWithLink": 186,
	"./components/SendWithLink.js": 186,
	"./components/Share": 188,
	"./components/Share.js": 188,
	"./components/ShareLink": 189,
	"./components/ShareLink.js": 189,
	"./components/Vendor": 197,
	"./components/Vendor.js": 197,
	"./components/Vendors": 198,
	"./components/Vendors.js": 198,
	"./components/WithdrawFromPrivate": 184,
	"./components/WithdrawFromPrivate.js": 184,
	"./contracts/ENS.abi": 171,
	"./contracts/ENS.abi.js": 171,
	"./contracts/ENS.address": 175,
	"./contracts/ENS.address.js": 175,
	"./contracts/ENS.blocknumber": 421,
	"./contracts/ENS.blocknumber.js": 421,
	"./contracts/ENSResolver.abi": 172,
	"./contracts/ENSResolver.abi.js": 172,
	"./contracts/ENSResolver.blocknumber": 422,
	"./contracts/ENSResolver.blocknumber.js": 422,
	"./contracts/Emitter.abi": 173,
	"./contracts/Emitter.abi.js": 173,
	"./contracts/Emitter.address": 176,
	"./contracts/Emitter.address.js": 176,
	"./contracts/Emitter.blocknumber": 423,
	"./contracts/Emitter.blocknumber.js": 423,
	"./contracts/Emitter.bytecode": 424,
	"./contracts/Emitter.bytecode.js": 424,
	"./contracts/Exchange.abi": 170,
	"./contracts/Exchange.abi.js": 170,
	"./contracts/Exchange.address": 249,
	"./contracts/Exchange.address.js": 249,
	"./contracts/Exchange.blocknumber": 425,
	"./contracts/Exchange.blocknumber.js": 425,
	"./contracts/StableCoin.abi": 174,
	"./contracts/StableCoin.abi.js": 174,
	"./contracts/StableCoin.address": 250,
	"./contracts/StableCoin.address.js": 250,
	"./contracts/StableCoin.blocknumber": 426,
	"./contracts/StableCoin.blocknumber.js": 426,
	"./contracts/StableCoin.bytecode": 427,
	"./contracts/StableCoin.bytecode.js": 427,
	"./contracts/contracts": 428,
	"./contracts/contracts.js": 428,
	"./customRPCHint.png": 414,
	"./cypherpunk.png": 416,
	"./dai.jpg": 204,
	"./ethereum.png": 109,
	"./i18n": 1,
	"./i18n/": 1,
	"./i18n/index": 1,
	"./i18n/index.js": 1,
	"./i18n/locales": 62,
	"./i18n/locales/": 62,
	"./i18n/locales/ca": 143,
	"./i18n/locales/ca.json": 143,
	"./i18n/locales/de": 144,
	"./i18n/locales/de.json": 144,
	"./i18n/locales/en": 140,
	"./i18n/locales/en.json": 140,
	"./i18n/locales/es": 142,
	"./i18n/locales/es.json": 142,
	"./i18n/locales/fr": 141,
	"./i18n/locales/fr.json": 141,
	"./i18n/locales/index": 62,
	"./i18n/locales/index.js": 62,
	"./i18n/locales/ro": 145,
	"./i18n/locales/ro.json": 145,
	"./index.scss": 417,
	"./localeth.png": 1098,
	"./qrcode.png": 260,
	"./wyre.jpg": 1099,
	"./xdai.jpg": 130
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1096;